import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mtop-15" }

import { ref, onUnmounted } from 'vue'
import { format } from 'date-fns'
import patientapi from "@/api/patientapi"
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { DateFormat } from "@/models/share.model"
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'lBarChangeCsDate',
  props: {
    onSaved: { type: Function }
  },
  setup(__props: any) {

const { t } = useI18n()
const props = __props;
const currentEntryStore = useCurrentEntryStore()
const oldEntryDate = new Date(currentEntryStore.currentEntryDate)

const selectedDate = ref<Date>(new Date(oldEntryDate))
const selectedTime = ref<string>(format(oldEntryDate, 'HH:mm:ss'))

function updateDate(newDate: Date) {
  selectedDate.value = newDate
}

function updateTime(timeString: string) {
  // timeString = "14:30:00"
  selectedTime.value = timeString
}

function getCombinedDateTime(): Date {
  const date = selectedDate.value
  const [hours, minutes, seconds] = selectedTime.value.split(':').map(Number)

  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    hours,
    minutes,
    seconds ?? 0
  )
}

onUnmounted(() => {
  const oldDate: Date = new Date(currentEntryStore.currentEntryDate);
  const oldIso: string = oldDate.toISOString();
  const newIso: string = getCombinedDateTime().toISOString();
  if (oldIso !== newIso) {
    patientapi.changeCurrentPatientEntryDate(newIso, currentEntryStore.currentEntryId)
        .then(() => {
          props.onSaved(newIso);
        })
  }
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_inputNewDate = _resolveComponent("inputNewDate")!
  const _component_esInputDateTime = _resolveComponent("esInputDateTime")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-modal w-maxC",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", null, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('patient.entry.time'),
        styles: "font-mBold"
      }, null, 8, ["txt"]),
      _createVNode(_component_inputNewDate, {
        ref: "hourRef",
        dateIso: _unref(currentEntryStore).currentEntryDate,
        showHeader: false,
        show: "time",
        onChanged: _cache[0] || (_cache[0] = ($event: any) => (updateTime($event))),
        class: "mtop-02"
      }, null, 8, ["dateIso"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_item, {
        txt: _unref(t)('patient.entry.date'),
        styles: "font-mBold"
      }, null, 8, ["txt"]),
      _createVNode(_component_esInputDateTime, {
        inline: "",
        dateTimeValue: _unref(oldEntryDate),
        dateFormat: _unref(DateFormat).DATEPICKER,
        onUpdateDateTime: _cache[1] || (_cache[1] = ($event: any) => (updateDate($event))),
        class: "mtop-04"
      }, null, 8, ["dateTimeValue", "dateFormat"])
    ])
  ]))
}
}

})